
  import { ref, computed, onMounted, onBeforeUnmount, defineComponent } from 'vue';
    
  interface Option {
      label: string;
      value: string | number;
    }
  
    export default defineComponent({
      name: 'SelectOption',
    props: {
        modelValue: Array,
          options: Array as () => Option[],
        disabled: Boolean
    },
    emits: ['update:modelValue', 'onChange'],  
    //@ts-ignore
      setup(props, { emit }) {
        const isOpen = ref(false);
        const wrapperRef = ref<HTMLElement | null>(null);
        const dropdownStyles = ref({});
  
        const selectedLabel = computed(() => {
              //@ts-ignore
            const selected = props?.options?.find(opt => opt.value === props.modelValue);
            return selected ? selected.label : 'Select validity';
        });
  
        const updateDropdownPosition = () => {
            if (!wrapperRef.value) return;
            const rect = wrapperRef.value.getBoundingClientRect();
            dropdownStyles.value = {
                position: 'absolute',
                top: `${rect.bottom + window.scrollY}px`,
                left: `${rect.left + window.scrollX}px`,
                width: `${rect.width}px`,
                zIndex: 9999
            };
        };
  
        const handleClickOutside = (e: MouseEvent) => {
            if (!wrapperRef.value?.contains(e.target as Node)) {
                isOpen.value = false;
            }
        };
  
        const toggleDropdown = () => {
            isOpen.value = !isOpen.value;
            if (isOpen.value) updateDropdownPosition();
        };
  
        const handleSelect = (option: { value: string | number; label: string }) => {
          //@ts-ignore
            const index = props?.options?.findIndex(opt => opt.value === option.value);
            emit('onChange', { value: option.value, index });
            emit('update:modelValue', option.value);
            isOpen.value = false;
        };
  
        onMounted(() => {
            window.addEventListener('resize', updateDropdownPosition);
            window.addEventListener('scroll', updateDropdownPosition);
            document.addEventListener('click', handleClickOutside);
        });
  
        onBeforeUnmount(() => {
            window.removeEventListener('resize', updateDropdownPosition);
            window.removeEventListener('scroll', updateDropdownPosition);
            document.removeEventListener('click', handleClickOutside);
        });
  
        return {
            isOpen,
            selectedLabel,
            toggleDropdown,
            handleSelect,
            dropdownStyles,
            wrapperRef
        };
    }
  });
  